/**
 * Initialize the sticky CTA behavior.
 */
function initStickyCTA() {
	let lastScrollPosition = 0;
	let isTicking = false;
	const classicCTA = document.querySelector(".mm-cta-classic");
	const stickyCTAs = document.querySelectorAll(".mm-cta-sticky");

	const classicTitle = document.querySelector(".mm-container-title-price");
	const stickyTitle = document.querySelectorAll(".mm-cta-sticky-info-left");

	if (!classicCTA || stickyCTAs.length === 0) {
		console.log("CTA elements not found:", { classicCTA, stickyCTAs });
		return;
	}

	if (!classicTitle || stickyTitle.length === 0) {
		console.log("TITLE elements not found:", { classicTitle, stickyTitle });
		return;
	}

	function toggleStickyCTA() {
		const classicCTARect = classicCTA.getBoundingClientRect();
		const isClassicCTAInView = classicCTARect.top >= 0 && classicCTARect.bottom <= window.innerHeight;

		const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;

		// Parcours de chaque élément stickyCTA pour appliquer les styles en fonction de la position de défilement
		stickyCTAs.forEach((stickyCTA) => {
			if (isAtBottom) {
				stickyCTA.classList.add("mm-none");
			} else if (!isClassicCTAInView) {
				stickyCTA.classList.remove("mm-none");
				stickyCTA.style.backgroundColor = ""; // Rétablir le style par défaut
			} else {
				stickyCTA.classList.add("mm-none");
				stickyCTA.style.backgroundColor = ""; // Rétablir le style par défaut
			}
		});
	}

	function toggleStickyTITLE() {
		if (window.innerWidth > 768) {
			return; // Arrête la fonction si la largeur est supérieure à 768px
		}

		const classicTITLERect = classicTitle.getBoundingClientRect();
		const isClassicTITLEInView = classicTITLERect.top >= 0 && classicTITLERect.bottom <= window.innerHeight;

		const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;

		// Parcours de chaque élément stickyCTA pour appliquer les styles en fonction de la position de défilement
		stickyTitle.forEach((stickyTitl) => {
			if (isAtBottom) {
				stickyTitl.classList.add("mm-none");
			} else if (!isClassicTITLEInView) {
				stickyTitl.classList.remove("mm-none");
				stickyTitl.style.backgroundColor = ""; // Rétablir le style par défaut
			} else {
				stickyTitl.classList.add("mm-none");
				stickyTitl.style.backgroundColor = ""; // Rétablir le style par défaut
			}
		});
	}

	toggleStickyCTA();
	toggleStickyTITLE();

	window.addEventListener("scroll", function () {
		const currentScrollPosition = window.scrollY;

		if (!isTicking) {
			window.requestAnimationFrame(function () {
				const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;

				// Parcourir chaque stickyCTA et appliquer la logique de changement de fond
				stickyTitle.forEach((stickyTitl) => {
					if (currentScrollPosition < lastScrollPosition && !isAtBottom) {
						stickyTitl.style.backgroundColor = ""; // Rétablir le fond lors du scroll vers le haut
					}
				});

				toggleStickyCTA();
				toggleStickyTITLE();

				lastScrollPosition = currentScrollPosition;
				isTicking = false;
			});
		}
		isTicking = true;
	});

	window.addEventListener("scroll", function () {
		const currentScrollPosition = window.scrollY;

		if (!isTicking) {
			window.requestAnimationFrame(function () {
				const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;

				// Parcourir chaque stickyCTA et appliquer la logique de changement de fond
				stickyCTAs.forEach((stickyCTA) => {
					if (currentScrollPosition < lastScrollPosition && !isAtBottom) {
						stickyCTA.style.backgroundColor = ""; // Rétablir le fond lors du scroll vers le haut
					}
				});

				toggleStickyCTA();
				toggleStickyTITLE();

				lastScrollPosition = currentScrollPosition;
				isTicking = false;
			});
		}
		isTicking = true;
	});
}

/**
 * Initialize the Splide carousel for the reassurance slider.
 */
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

// Splide complementary product
document.addEventListener("DOMContentLoaded", function () {
	waitForElement();
});

function waitForElement() {
	var id = ".splide-reco";
	var splideElem = document.querySelector(id);
	var bar = document.querySelector(".my-carousel-progress-bar-reco");

	if (splideElem != null && splideElem.querySelectorAll(".splide__slide-reco") != null) {
		mmSplideInit(splideElem, bar);
	} else {
		setTimeout(waitForElement, 2000);
	}
}

function mmSplideInit(splideElem, bar) {
	var splide = new Splide(splideElem, {
		type: "slide",
		arrows: false,
		pagination: false,
		gap: 15,
		omitEnd: true,
		perPage: 1,
		breakpoints: {
			768: {
				perPage: 1,
				arrows: false,
				pagination: false,
				perMove: 1,
				padding: {
					left: 0,
					right: 0,
				},
			},
		},
	}).mount();

	splide.on("moved", function () {
		var end = splide.Components.Controller.getEnd() + 1;
		var rate = Math.min((splide.index + 1) / end, 1);
		bar.style.width = String(100 * rate) + "%";
	});
}

// CTA order
// Ouvrir la modale
function mmOpenOrder() {
	const modalCTASticky = document.querySelector(".mm-cta-sticky-desk");
	const CTAStickyOrder = document.querySelector(".mm-cta-sticky-order");
	const modalBg = document.querySelector(".mm-modal-bg-order");

	modalCTASticky.classList.add("mm-show-modal");
	CTAStickyOrder.classList.add("mm-hide-modal");
	modalBg.classList.add("mm-show-modal-bg");

	document.querySelector("html").classList.add("stop-scrolling");
	modalBg.addEventListener("click", mmCloseOrder);
}

// Fermer la modale
function mmCloseOrder() {
	const modalCTASticky = document.querySelector(".mm-cta-sticky-desk");
	const CTAStickyOrder = document.querySelector(".mm-cta-sticky-order");
	const modalBg = document.querySelector(".mm-modal-bg-order");

	modalCTASticky.classList.remove("mm-show-modal");
	modalBg.classList.remove("mm-show-modal-bg");
	modalBg.classList.add("mm-hide-modal-bg");

	document.querySelector("html").classList.remove("stop-scrolling");

	CTAStickyOrder.classList.remove("mm-hide-modal");
	CTAStickyOrder.classList.remove("mm-none");

	modalBg.removeEventListener("click", mmCloseOrder);
}

// Info delivery
// Ouvrir la modale
function mmOpenInfoDelivery() {
	const modalSurface = document.querySelector(".mm-surface-modale-delivery");
	modalSurface.classList.add("mm-modal-is-open-delivery");
	document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer la modal
function mmCloseInfoDelivery() {
	const modalSurface = document.querySelector(".mm-surface-modale-delivery");

	// Fermer la modal
	document.querySelector("html").classList.remove("stop-scrolling");
	modalSurface.classList.remove("mm-modal-is-open-delivery");
}

// Size Guide
// Ouvrir la modale
function mmOpenSizeGuide() {
	const modalSurface = document.querySelector(".mm-surface-modale");
	modalSurface.classList.add("mm-modal-is-open");
	document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer la modale avec transition
function mmCloseSizeGuide() {
	const modalSurface = document.querySelector(".mm-surface-modale");
	const videosTesti = document.querySelectorAll(".mm-id-video");

	// Fermer la modal
	modalSurface.classList.remove("mm-modal-is-open");
	document.querySelector("html").classList.remove("stop-scrolling");

	// Arrêter toutes les vidéos dans la modal
	videosTesti.forEach((videoContainer) => {
		const video = videoContainer.querySelector("video");
		const iframe = videoContainer.querySelector("iframe");

		// Si c'est un élément <video> (HTML5)
		if (video) {
			video.pause(); // Mettre la vidéo en pause
			video.currentTime = 0; // Réinitialiser la vidéo
		}

		// Si c'est une vidéo YouTube intégrée via <iframe>
		if (iframe && iframe.src.includes("youtube.com")) {
			const iframeSrc = iframe.src;
			iframe.src = ""; // Vider le src pour arrêter la vidéo
			iframe.src = iframeSrc; // Restaurer le src si besoin de relancer plus tard
		}
	});
}

// Video play
document.addEventListener("DOMContentLoaded", function () {
	const videosTesti = document.querySelectorAll(".mm-id-video");
	videosTesti.forEach((videoContainer) => {
		const video = videoContainer.querySelector("video");
		const iframe = videoContainer.querySelector("iframe");
		const playBtn = videoContainer.closest(".mm-wrapper-video-guide-size").querySelector(".play-btn");
		const pauseBtn = videoContainer.closest(".mm-wrapper-video-guide-size").querySelector(".pause-btn");

		// Si c'est un élément <video>
		if (video) {
			// Vérifier si playBtn existe avant d'ajouter un écouteur
			if (playBtn) {
				playBtn.addEventListener("click", () => {
					if (video.paused) {
						video.play();
					} else {
						video.pause();
					}
				});
			}

			// Gérer les événements de pause/lecture pour changer l'apparence du bouton
			video.addEventListener("pause", () => {
				if (playBtn) playBtn.style.opacity = "1";
				if (pauseBtn) pauseBtn.style.opacity = "0";
			});

			video.addEventListener("play", () => {
				if (playBtn) playBtn.style.opacity = "0";
				if (pauseBtn) pauseBtn.style.opacity = "1";
			});
		}
		// Si c'est une vidéo YouTube
		else if (iframe) {
			// Assurez-vous que l'iframe est une vidéo YouTube
			if (iframe.src.includes("youtube.com")) {
				// Charger l'API YouTube IFrame
				const tag = document.createElement("script");
				tag.src = "https://www.youtube.com/iframe_api";
				document.body.appendChild(tag);

				// Créer un lecteur YouTube via l'API YouTube
				let player;
				function onYouTubeIframeAPIReady() {
					player = new YT.Player(iframe, {
						events: {
							onStateChange: onPlayerStateChange,
						},
					});
				}

				// Ajouter des écouteurs d'événements pour les boutons play/pause
				if (playBtn) {
					playBtn.addEventListener("click", () => {
						if (player) {
							const state = player.getPlayerState();
							if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.CUED) {
								player.playVideo();
							} else {
								player.pauseVideo();
							}
						}
					});
				}
				// Mettre à jour les boutons en fonction de l'état du lecteur YouTube
				function onPlayerStateChange(event) {
					if (event.data === YT.PlayerState.PLAYING) {
						if (playBtn) playBtn.style.opacity = "0";
						if (pauseBtn) pauseBtn.style.opacity = "1";
					} else if (event.data === YT.PlayerState.PAUSED) {
						if (playBtn) playBtn.style.opacity = "1";
						if (pauseBtn) pauseBtn.style.opacity = "0";
					}
				}
			}
		} else {
			console.error("Aucun élément vidéo ou iframe trouvé dans le conteneur", videoContainer);
		}
	});
});

// Update price
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll(".mm-update-price");

	priceAll.forEach(function (price) {
		var promoQtty = parseFloat(price.dataset.promoQuantity);
		var unitPrice = parseFloat(price.dataset.value) / 100; // Prix à l'unité en euros
		var totalPrice;

		if (!isNaN(promoQtty) && qtty >= promoQtty) {
			totalPrice = (parseFloat(price.dataset.promoPrice) * qtty) / 100;
		} else {
			totalPrice = unitPrice * qtty;
		}
		var formattedPrice = totalPrice.toFixed(2);
		var euros = Math.floor(totalPrice);
		var cents = Math.round((totalPrice - euros) * 100);
		price.innerHTML = euros + "€" + (cents > 0 ? cents : "00"); // Affichage
	});
}

// Quantity selector
function mmChangeQtty(delta, inputId) {
	var input = document.getElementById(inputId);
	if (delta == "-1" && input.value == "1") {
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
		input.value = newValue;
		mmUpdatePrice(newValue);

		const event = new Event("change");
		input.dispatchEvent(event);
	}
}

function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll(".mm-product-price");
	priceAll.forEach(function (price) {
		price.innerHTML = ((price.dataset.value * qtty) / 100).toFixed(2) + "€";
	});
}

// Class for handling variant selection
class VariantSelector extends HTMLElement {
    constructor() {
        super();
        this.cached = {};
        this.container = this.closest("#product-form");
// ajout de la vérification
        if (!this.container) {
            console.error("Element #product-form not found.");
            return;
        }

        this.addEventListener("change", this.onVariantChange.bind(this));
    }

    /**
     * Handle variant change event.
     */
    onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();

        if (this.currentVariant) {
            this.updateURL();
            this.updateMedia();
            this.variantFetch();
        }
    }

    /**
     * Get the variant data based on the variant ID in the URL.
     *
     * @param {string} variantId - The variant ID from the URL.
     */
    getSelectedVariantById(variantId) {
		// 		this.currentVariant = this.getVariantJSON().find((variant) => variant.id == variantId);
        this.currentVariant = this.getVariantJSON().find(variant => variant.id == variantId);
    }

    /**
     * Get selected options from the variant checkboxes.
     */
    getSelectedOptions() {
		// 		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);

        this.options = Array.from(
            this.querySelectorAll(".mm-product-variant-checkbox:checked"),
            checkbox => checkbox.value
        );
    }

    /**
     * Get variant data from the embedded JSON.
     *
     * @returns {Object} - The variant data.
     */
    getVariantJSON() {
		// Ajout de la verification
		// this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		// return this.variantData;

        if (!this.variantData) {
            const jsonElement = this.querySelector('[type="application/json"]');
            if (!jsonElement) {
                console.error("No JSON data found for variants.");
                return [];
            }
            this.variantData = JSON.parse(jsonElement.textContent);
        }
        return this.variantData;
    }

    /**
     * Get the selected variant based on selected options.
     */
    getSelectedVariant() {
        this.currentVariant = this.getVariantJSON().find(variant =>
            variant.options.every((option, index) => this.options[index] === option)
        );
		// avant
			// 	this.currentVariant = this.getVariantJSON().find((variant) => {
			// 		const findings = !variant.options
			// 		.map((option, index) => {
			// 			return this.options[index] === option;
			// 		})
			// 		.includes(false);

			// 	if (findings) return variant;
			// });
    }

    /**
     * Update the product media (images/videos) based on the selected variant.
     */
	updateMedia() {
		const selects = document.querySelectorAll(`.mm-db-variant-media[data-option-1="${this.currentVariant.option1}"]`);
		const firstImage = document.querySelector(".mm-product-thumbnail-image-1");
		const mediaContainer = document.querySelector(".mm-splide-media-product .splide__list");
		const thumbnailContainer = document.querySelector(".mm-product-media-thumbnail");
	
		for (const select of selects) {
			const optionsArray = Array.from(select.options);
			if (optionsArray.some(option => option.value !== "")) {
				if (!firstImage?.src.includes(optionsArray[0].value)) {
					mediaContainer.innerHTML = "";
					thumbnailContainer.innerHTML = "";
	
					optionsArray.forEach((option, index) => {
						const mediaClass = `mm-product-media-${index + 1}`;
						const dataType = option.dataset.type; // Récupération correcte du data-type
						let mediaHTML = "";
						let thumbnailHTML = "";
	
						if (dataType === "image") {
							mediaHTML = `
								<li class="splide__slide">
									<img src="https://www.maxandthecity.com/cdn/shop/${option.value}?width=1000" 
										alt="${option.text}" 
										width="1000" 
										height="1000" 
										class="${mediaClass}">
								</li>
							`;
						} else if (dataType === "video") {
							mediaHTML = `
								<li class="splide__slide">
									<video class="${mediaClass} mm-w-full mm-h-full mm-product-media" playsinline autoplay loop muted>
										<source src="${option.value}" type="video/mp4">
										Votre navigateur ne supporte pas la vidéo.
									</video>
								</li>
							`;
						}
	
						mediaContainer.insertAdjacentHTML("beforeend", mediaHTML);
	
						const activeClass = index === 0 ? "mm-active" : "";
						const thumbnailClass = `mm-product-thumbnail-image-${index + 1}`;
	
						if (dataType === "image") {
							thumbnailHTML = `
								<div class="mm-product-thumbnail-image-container ${activeClass}" data-index="${index}">
									<img src="https://www.maxandthecity.com/cdn/shop/${option.value}?width=100" 
										alt="${option.text}" 
										width="100" 
										height="100" 
										class="${thumbnailClass}">
								</div>
							`;
						} else if (dataType === "video") {
							thumbnailHTML = `
								<div class="mm-product-thumbnail-image-container ${activeClass}" data-index="${index}">
									<video class="${thumbnailClass} mm-wrapper-video-thumbnail" playsinline autoplay loop muted poster="${option.value}?width=300">
										<source src="${option.value}" type="video/mp4">
									</video>
								</div>
							`;
						}
	
						thumbnailContainer.insertAdjacentHTML("beforeend", thumbnailHTML);
					});
	
					// Réinitialisation de la pagination du slider
					const pagination = document.querySelector(".mm-product-media-slider .splide__pagination");
					if (pagination) pagination.innerHTML = "";
	
					initSplideMediaProduct(optionsArray.length);
				}
				break;
			}
		}
	}

    /**
     * Update the URL to include the selected variant ID.
     */
    updateURL() {
        if (this.currentVariant?.id) {
            window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
            console.log("Variant ID updated:", this.currentVariant.id);
        }
    }

    /**
     * Fetch variant data from the server and cache it.
     */
    variantFetch() {
        const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

        if (this.cached[variantUrl]) {
            this.renderVariantInfo(this.cached[variantUrl]);
            return;
        }

        fetch(variantUrl, { mode: "cors" })
            .then(response => response.text())
            .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.cached[variantUrl] = html;
                this.renderVariantInfo(html);
            })
            .catch(error => console.error("Variant fetch error:", error));
    }

    /**
     * Render variant information in the DOM.
     */
    renderVariantInfo(html) {
        [
            "#product_id",
            ".mm-container-price-wrapper",
            ".mm-reduce-price",
            ".mm-product-form-variant-color",
            ".mm-cta-classic",
            ".mm-product-title",
            ".mm-product-quantity",
            ".mm-selected-option",
            ".mm-pre-order-cta-sticky",
            ".mm-wrapper-price-sticky-mobile",
            ".mm-cta-sticky-order-content",
            ".mm-btn-pre-order",
            ".mm-logic",
            ".mm-bloc-product-upsell",
            ".mm-bloc-delivery",
            ".mm-container-selector-cta",
            ".mm-product-reco"
        ].forEach(selector => this.updateElementOuter(selector, html));

        this.updateMultipleElement(".mm-product-variant-select", html);
        initStickyCTA();
    }

    /**
     * Update the outer HTML of an element.
     */
    updateElementOuter(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (destination && source) {
            destination.replaceWith(source.cloneNode(true));
        }
    }

    /**
     * Update multiple elements.
     */
    updateMultipleElement(selector, html) {
        const destination = this.container.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);
        if (source.length === destination.length) {
            destination.forEach((element, index) => element.replaceWith(source[index].cloneNode(true)));
        }
    }
}

// Define the custom element
customElements.define("variant-selector", VariantSelector);

// Initialize dropdowns and sticky CTA
document.addEventListener("DOMContentLoaded", () => {
    mmSlideProductReassurance();
    initStickyCTA();
    mmInitDropdowns();
});

function mmInitDropdowns() {
    document.querySelectorAll(".mm-dropdown-title-wrapper").forEach(dropdown => {
        const content = dropdown.parentElement.querySelector(".mm-mobile-dropdown");
        if (content) {
            content.style.maxHeight = content.scrollHeight + "px";
            dropdown.classList.add("active");
        }
        dropdown.addEventListener("click", function () {
            this.classList.toggle("active");
            content.style.maxHeight = content.style.maxHeight === "0px" ? content.scrollHeight + "px" : "0px";
        });
    });
}

// Define the custom element
customElements.define("variant-selector", VariantSelector);

document.addEventListener("DOMContentLoaded", () => {
	mmSlideProductReassurance();
	initStickyCTA();
});

//  ADD product complementary smiley
function mmHandleAddOrRemoveProduct(element) {
	const variantId = element.getAttribute("data-variant-id"); // Récupérer l'ID de la variante via l'attribut data
	const isChecked = element.checked; // Vérifie si la checkbox est cochée ou non

	if (isChecked) {
		// Si la checkbox est cochée, on ajoute le produit au panier
		mmAddProductToCart(variantId);
		console.log("Produit ajouté au panier : " + variantId);
	} else {
		// Si la checkbox est décochée, on supprime le produit du panier
		mmDestroyProductFromCart(variantId);
		console.log("Produit supprimé du panier : " + variantId);
	}
}

// dropdown DETAILS en mobile
document.addEventListener("DOMContentLoaded", function () {
	let dropdowns = document.querySelectorAll(".mm-dropdown-title-wrapper");

	dropdowns.forEach(function (dropdown) {
		const content = dropdown.parentElement.querySelector(".mm-mobile-dropdown");
		if (content) {
			content.style.maxHeight = content.scrollHeight + "px"; // Définit la hauteur maximale pour ouvrir le dropdown
			dropdown.classList.add("active"); // Ajoute la classe active pour appliquer les styles du dropdown ouvert
		}

		dropdown.addEventListener("click", function () {
			this.classList.toggle("active");
			const content = this.parentElement.querySelector(".mm-mobile-dropdown");
			if (content.style.maxHeight && content.style.maxHeight !== "0px") {
				content.style.maxHeight = "0px";
			} else {
				content.style.maxHeight = content.scrollHeight + "px";
			}
		});
	});
});

// Parallax section text image cta
window.onload = function () {
	function initializeGsapIfWideScreen() {
		if (window.matchMedia("(min-width: 1200px)").matches) {
			gsap.registerPlugin(ScrollTrigger);

			const imageContainers = document.querySelectorAll(".mm-img-ti");

			imageContainers.forEach((image) => {
				gsap.to(image, {
					yPercent: 35,
					ease: "none",
					scrollTrigger: {
						trigger: image.parentNode,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
					},
				});
			});
		}
	}

	initializeGsapIfWideScreen();
	window.addEventListener("resize", initializeGsapIfWideScreen);
};

// change img sticky select variant
// Fonction pour ouvrir et fermer le menu déroulant
function mmHandleSelect(id) {
	const dropdown = document.getElementById(id);
	if (dropdown) {
		dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
	}
}

// Fermer le dropdown si on clique en dehors
document.addEventListener("click", function (event) {
	const dropdowns = document.querySelectorAll(".mm-dropdown-menu");
	const triggers = document.querySelectorAll(".mm-dropdown-trigger");

	let clickedInside = false;

	triggers.forEach((trigger) => {
		if (trigger.contains(event.target)) {
			clickedInside = true;
		}
	});

	if (!clickedInside) {
		dropdowns.forEach((dropdown) => {
			dropdown.style.display = "none";
		});
	}
});

function selectVariantOption(optionElement, id, wrapperId) {
	const value = optionElement.getAttribute("data-value");
	const imageUrl = optionElement.getAttribute("data-image-url");

	document.getElementById(id).innerText = value;
	const selectWrapper = document.getElementById(wrapperId);
	var imgElement = selectWrapper.querySelector(".mm-variant-img-selected");

	if (imgElement) {
		imgElement.src = imageUrl;
		imgElement.srcset = imageUrl;
	}
}

// Synchronize sticky variant selector with main on product page
function syncVariantSelectors() {
	const main_variant_selector = document.querySelector("variant-selector");
	const sticky_variant_selector = document.querySelector("variant-selector-sticky");

	// 1 si on change le sticky_variant_selector
	// on va regarder l'option qui a été changée (via event listener click sur option) - on chope le name de l'option
	const sticky_options = sticky_variant_selector.querySelectorAll(".mm-dropdown-item");
	sticky_options.forEach(function (sticky_option) {
		sticky_option.addEventListener("click", function (event) {
			const optionValue = sticky_option.dataset.value;
			// on va regarder dans le main_variant_selector, et on va cherche l'option qui a la même value
			const main_input_to_activate = main_variant_selector.querySelector(`input[value="${optionValue}"]`);
			// on clique dessus
			main_input_to_activate.click();
		});
	});

	// 2 si on change le main_variant_selector
	// on trigger un evenement 'change' sur le main_variant_selector
	const main_options = main_variant_selector.querySelectorAll(".mm-product-variant-checkbox");
	main_options.forEach(function (main_option) {
		main_option.addEventListener("click", function (event) {
			const optionValueMain = main_option.value; // Utilise .value au lieu de dataset
			// Cherche l'option correspondante dans le sticky_variant_selector
			const sticky_input_to_activate = sticky_variant_selector.querySelector(`.mm-dropdown-item[data-value="${optionValueMain}"]`);
			if (sticky_input_to_activate) {
				sticky_input_to_activate.classList.add("active");
				sticky_input_to_activate.click();
			} else {
				console.error("No matching sticky option found for value:", optionValueMain);
			}
		});
	});
}

document.addEventListener("DOMContentLoaded", function () {
	syncVariantSelectors();
});

document.addEventListener("DOMContentLoaded", function () {
	var ticking = false;

	// Observer pour détecter quand l'iframe est ajouté au DOM
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.id === 'klaviyo-bis-iframe') {
                    synchronizePositions();
                    // Réappliquer les styles après un court délai pour s'assurer que l'iframe est complètement chargée
                    setTimeout(synchronizePositions, 100);
                }
            });
        });
    });

    // Observer le document pour détecter l'ajout de l'iframe
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    function synchronizePositions() {
        var element = document.querySelector(".mm-container-selector-cta");
        var productWrapper = document.querySelector(".mm-container-product-form");
        var iframeElement = document.getElementById("klaviyo-bis-iframe");

        if (!element || !productWrapper || !iframeElement) {
            return;
        }

        var rect = element.getBoundingClientRect();
        var topPosition = rect.top + window.scrollY;
        var productWrapperWidth = productWrapper.getBoundingClientRect().width;

        iframeElement.style.position = "absolute";
        iframeElement.style.top = topPosition + "px";
        iframeElement.style.width = "100%";
        iframeElement.style.height = "fit-content";
    
		// Charger immédiatement la largeur du container dans l'iframe
        var iframeDocument = iframeElement.contentWindow.document;
        iframeElement.onload = function () {
            var containerElement = iframeDocument.getElementById("container");

            if (containerElement) {
                // Applique immédiatement la largeur du parent pour éviter les glitches
                containerElement.style.width = productWrapperWidth + "px";
            } else {
                console.log("Élément #container non trouvé dans l'iframe.");
            }
        };

        // Si l'iframe est déjà chargée, exécuter immédiatement
        if (iframeElement.contentWindow.document.readyState === 'complete') {
            iframeElement.onload();
        }
    }

	function closeElement() {
		var iframeElement = document.getElementById("klaviyo-bis-iframe");
		if (iframeElement) {
			iframeElement.style.display = "none";
		}
	}

	function requestTick() {
		if (!ticking) {
			requestAnimationFrame(function () {
				synchronizePositions();
				ticking = false;
			});
			ticking = true;
		}
	}

	// Initialisation
	synchronizePositions();

	// Écouter les changements de variant
	document.addEventListener("variant:changed", function() {
        synchronizePositions();
    });

	var triggerElement = document.querySelector(".klaviyo-bis-trigger");
	if (triggerElement) {
		triggerElement.addEventListener("click", function () {
			var iframeElement = document.getElementById("klaviyo-bis-iframe");
			if (iframeElement) {
				iframeElement.style.display = "block";
				synchronizePositions();
			}
		});
	}

	document.addEventListener("click", function (event) {
		var iframeElement = document.getElementById("klaviyo-bis-iframe");
		var triggerElement = document.querySelector(".klaviyo-bis-trigger");

		if (iframeElement) {
			var iframeDocument = iframeElement.contentWindow.document;
			var containerElement = iframeDocument.getElementById("container");

			if (triggerElement) {
				if (!iframeElement.contains(event.target) && !triggerElement.contains(event.target) && (!containerElement || !containerElement.contains(event.target))) {
					closeElement();
				}
			}
		}
	});

	if (window.innerWidth > 768) {
		document.addEventListener("scroll", function () {
			var iframeElement = document.getElementById("klaviyo-bis-iframe");
			if (iframeElement && window.getComputedStyle(iframeElement).display !== "none") {
				iframeElement.style.display = "none";
			}
		});
	}

	window.addEventListener("resize", requestTick);
	window.addEventListener("scroll", requestTick);
});


function scrollToMainContent() {
    if (window.innerWidth < 1024) { // Vérifie si l'écran est inférieur à 1024px
        const target = document.getElementById('MainContent');
        if (target) {
            const offset = 100; // Décalage en pixels
            const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
    }
}
